import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ChapterCard } from '../components/ChapterCard';
import { NicheGrid } from '../components/NicheGrid';
import { AILayerStack } from '../components/AILayerStack';
import { HookExamples } from '../components/HookExamples';
import { RoutineTimeline } from '../components/RoutineTimeline';
import { PaymentMethods } from '../components/PaymentMethods';
import { BonusSection } from '../components/BonusSection';
import { GoldDivider } from '../components/ui/GoldDivider';
import { MidChapterCTA } from '../components/MidChapterCTA';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
export function GuidePage() {
  return <div className="min-h-screen bg-[#0a1628] text-white selection:bg-[#d4a843] selection:text-[#0a1628] overflow-x-hidden" data-id="element-194">
      <HeroSection data-id="element-195" />

      {/* Chapter 1 */}
      <ChapterCard number={1} title="La Economía del Anonimato" subtitle="El Cambio de Chip" className="bg-[#1a2744]" data-id="element-196">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-197">
          <div className="bg-[#0a1628] p-8 rounded-xl border-l-4 border-[#d4a843] shadow-lg" data-id="element-198">
            <h3 className="text-[#d4a843] font-bold text-lg mb-3 uppercase tracking-wider" data-id="element-199">
              Concepto Clave
            </h3>
            <p className="text-xl text-white font-serif leading-relaxed" data-id="element-200">
              "El contenido es el protagonista, no la persona."
            </p>
          </div>
          <div className="bg-[#0a1628] p-8 rounded-xl border-l-4 border-[#e8c66a] shadow-lg" data-id="element-201">
            <h3 className="text-[#e8c66a] font-bold text-lg mb-3 uppercase tracking-wider" data-id="element-202">
              Ventaja
            </h3>
            <p className="text-xl text-white font-serif leading-relaxed" data-id="element-203">
              "Puedes fallar sin exponerte y multiplicar canales sin revelar tu
              identidad."
            </p>
          </div>
        </div>
      </ChapterCard>

      <GoldDivider data-id="element-204" />

      {/* Chapter 2 */}
      <ChapterCard number={2} title="Nichos de Alta Retención" subtitle="Dónde Está el Dinero" data-id="element-205">
        <NicheGrid data-id="element-206" />
      </ChapterCard>

      <GoldDivider data-id="element-207" />

      {/* CTA 1 */}
      <MidChapterCTA hookText="Accede al método completo por solo $497 MXN" data-id="element-208" />

      {/* Chapter 3 */}
      <ChapterCard number={3} title="Tu Equipo de IA" subtitle="El Sistema de 3 Capas" className="bg-[#1a2744]" data-id="element-209">
        <AILayerStack data-id="element-210" />
      </ChapterCard>

      <GoldDivider data-id="element-211" />

      {/* Chapter 4 */}
      <ChapterCard number={4} title="La Fórmula del Gancho" subtitle="Hook de 3 Segundos" data-id="element-212">
        <HookExamples data-id="element-213" />
      </ChapterCard>

      <GoldDivider data-id="element-214" />

      {/* CTA 2 */}
      <MidChapterCTA hookText="¿Lista para dominar los ganchos? Obtén la guía completa" data-id="element-215" />

      {/* Chapter 5 */}
      <ChapterCard number={5} title="Rutina Invisible" subtitle="60 Minutos al Día" className="bg-[#1a2744]" data-id="element-216">
        <RoutineTimeline data-id="element-217" />
      </ChapterCard>

      <GoldDivider data-id="element-218" />

      {/* Chapter 6 */}
      <ChapterCard number={6} title="Cómo Cobrar en México" subtitle="Monetización Real" data-id="element-219">
        <PaymentMethods data-id="element-220" />
      </ChapterCard>

      <GoldDivider data-id="element-221" />

      {/* CTA 3 */}
      <MidChapterCTA hookText="Empieza a generar ingresos invisibles hoy mismo" data-id="element-222" />

      {/* Bonus Section */}
      <section className="py-16 px-4 max-w-5xl mx-auto" data-id="element-223">
        <BonusSection data-id="element-224" />
      </section>

      {/* Final Large CTA */}
      <FinalCTA data-id="element-225" />

      {/* Footer */}
      <Footer data-id="element-226" />
    </div>;
}